import { INode } from "../types/INode"
import { Node } from "../types/Node"
import { Finder, IFinder } from "../finder/IFinder"

export class Dict {

    priorytety: any[] = [
        { nr:1, text: "1. AWARIA",  opis:"nagły brak możliwości pracy na urządzeniu"},
        { nr:2, text: "2. SERWIS",  opis:"planowy serwis urządzenia"},
        { nr:3, text: "3. ZGŁOSZENIE",  opis:"prace nie wpływające na wydajność produkcji"},
    ]

    statusy: any[] = [
        { nr:1, text: "1. ZGŁOSZONY"},
        { nr:2, text: "2. PRACA ROZPOCZĘTA"},
        { nr:2, text: "3. PRACA ZAKOŃCZONA"},
        { nr:4, text: "4. ZAMKNIĘTY"},
    ]

}

export interface IProblem extends INode {
    type:string;
    version:number;
    _id:string|undefined
    parent_id:string
    _err:any;
    fnd:string;
    del:number;

    idn:string;
    device_id: any;
    device_rodzaj:string|undefined;
    device_idn:string|undefined;

    priorytet:string|undefined;
    opis:string;
    status:string;

    data_zgloszenia:Date|undefined;
    data_zamkniecia:Date|undefined;
    data_rozpoczecia_pracy:Date|undefined;
    data_zakonczenia_pracy:Date|undefined;

    zglosil:string;
    zakonczyl:string;
    pracownicy_warsztatu:string[];
    
}
  
export class Problem implements IProblem {
    type:string="problem";
    version:number=0;
    _id:string|undefined = undefined;
    parent_id:string=""
    idn:string = ""
    _err:any={};
    fnd:string=""
    del:number=0


    device_id: any;
    device_rodzaj:string|undefined=undefined;
    device_idn:string|undefined=undefined;

    priorytet:string|undefined="";
    opis:string="";
    status:string="1. ZGŁOSZONY";

    data_zgloszenia:Date|undefined=undefined;
    data_rozpoczecia_pracy:Date|undefined=undefined;
    data_zakonczenia_pracy:Date|undefined=undefined;
    data_zamkniecia:Date|undefined;
    
    zglosil:string="";
    zakonczyl:string="";

    pracownicy_warsztatu:string[]=[];

}

